<template>
  <v-card>

    <!-- Main Toolbar -->
    <v-toolbar dense dark flat :color="appColor_Medium">
      <v-toolbar-title>{{ title }}</v-toolbar-title>

      <v-spacer />

      <v-toolbar-items>
        <v-btn :color="appColor_Dark" @click="close()" class="elevation-0">
          Close
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <!-- Data Table -->
    <v-data-table
      :headers="headers"
      :items="filteredDetails"
      :loading="isLoading"
      :search="search"
      :no-data-text="noDataText"
      class="pa-1"
      >

      <v-progress-linear slot="progress" :color="appColor_Progress" indeterminate />

      <template v-slot:top>
        <!-- Filters -->
        <v-row no-gutters class="mx-3 mt-2">

          <!-- Search -->
          <v-col cols="12" md="12">
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              :disabled="isLoading"
              clearable
            />
          </v-col>
        </v-row>
      </template>

      <template v-slot:body="{ items }">
        <tbody>
          <tr :class="item.isWarning ? 'custom-highlight-row' : ''" v-for="(item) in items" :key="item.id">
            <td><span>{{ item.kiosk }}</span></td>
            <td><span>{{ item.resident }}</span></td>
            <td><span>{{ item.user }}</span></td>
            <td><span>{{ getDirectionAbbr(item.direction) }}</span></td>
            <td>
              <span class="text-left"><app-date :date="item.lastOpened" :format="'MM/DD/YYYY'"/></span>
            </td>
            <td><span>{{ item.subject }}</span></td>
            <td><span>{{ getContentType(item.blobName) }}</span></td>
            <td><span>{{ item.statusMessage }}</span></td>
          </tr>
        </tbody>
      </template>
    </v-data-table>

  </v-card>
</template>

<script>
import appService from '@/app.service.js'
import { AppColor } from '@/config.js'
import AppDate from '@/components/App/AppDate'

export default {
  name: 'MessagePurgeDetail',
  components: {
    AppDate
  },
  props: {
    messagePurgeId: {
      type: Number,
      default: -1
    },
    datePurged: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      // colors
      appColor_Medium: AppColor.Medium,
      appColor_Dark: AppColor.Dark,
      appColor_Progress: AppColor.Progress,

      isLoading: true,
      search: '',

      headers: [
        {
          text: 'Kiosk',
          value: 'kiosk',
          align: 'left',
          width: '10%',
          class: 'pr-0'
        },
        {
          text: 'Resident',
          value: 'resident',
          align: 'left',
          width: '15%',
          class: 'pr-0'
        },
        {
          text: 'User',
          value: 'user',
          align: 'left',
          width: '15%',
          class: 'pr-0'
        },
        {
          text: 'Direction',
          value: 'direction',
          align: 'left',
          width: '10%'
        },        
        {
          text: 'Opened',
          value: 'lastOpened',
          align: 'left',
          width: '10%',
          class: 'pr-0'
        },
        {
          text: 'Subject',
          value: 'subject',
          align: 'left',
          width: '15%',
          class: 'pr-0'
        },
        {
          text: 'Type',
          value: 'blobName',
          align: 'left',
          width: '5%',
          class: 'pr-0'
        },
        {
          text: 'Status Message',
          value: 'statusMessage',
          align: 'left',
          width: '20%',
          class: 'pr-0'
        }
      ],
      messagePurgeDetails: []
    }
  },
  computed: {
    noDataText () {
      if (this.isLoading) return 'One moment...'

      return this.messagePurgeDetails.length === 0
        ? 'No message purge details found'
        : ''
    },
    formattedDate () {
      if (this.datePurged !== null) {
        if (this.datePurged.length > 0) {
          return this.$moment(this.datePurged).format('ddd, MMM DD, YYYY')
        }
      }
      return null
    },
    title () {
      return `Message Purge Details - ${this.formattedDate}`
    },
    filteredDetails() {
      if (this.messagePurgeDetails === null) return []
      const self = this
      return self.messagePurgeDetails.filter(p => {
        return (
          p.messagePurgeId > 0
        )
      })
    }
  },
  methods: {
    loadData() {
      const self = this
      self.isLoading = true
      if (self.id < 0) return
      self.messagePurgeDetails = []

      setTimeout(() => {
        appService.getMessagePurgeDetails(self.messagePurgeId).then(data => {
          if (data.errorSeverity > 0) {
            self.handleError(data)
          } else {
            self.messagePurgeDetails = data.messagePurgeDetails
          }
            self.isLoading = false
        }).catch(e => { self.handleCriticalError(e) })
      }, 300)
    },

    getDirectionAbbr(direction) {
      return direction === 'User To Resident'
        ? 'To Resident'
        : 'To User'
    },

    getContentType(blobName) {
      if (blobName === null) return null
      const blobParts = blobName.split('/')
      return blobParts[0] === 'voice-message'
        ? 'voice'
        : blobParts[0]
    },

    close () {
      this.$emit('close')
    },

    handleError (result) {
      this.$error.show({
        title:
          result.errorSeverity === 0 ? 'Validation Failed' : 'Internal Error',
        text: result.errorMessage,
        severity: result.errorSeverity
      })
    }
  },
  mounted() {
    this.loadData()
  },
  watch: {
    messagePurgeId (oldValue, newValue) {
      if (oldValue !== newValue) {
        this.loadData()
      }
    }
  }
}
</script>

<style scoped>
.custom-highlight-row{
  background-color: rgb(255, 238, 182);
}
</style>
